import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@ooh/ui/components/select';
import { AVAILABILITY_COLUMN_WIDTH } from '../../../availability';

export type Granularity = 'half-month' | 'month' | 'week' | 'day';

export const GRANULARITY_OPTIONS: { value: Granularity; label: string }[] = [
  { value: 'half-month', label: 'Połówki miesiąca' },
  { value: 'month', label: 'Miesiące' },
  { value: 'week', label: 'Tygodnie' },
  { value: 'day', label: 'Dni' },
];

// Derived from the canonical AVAILABILITY_COLUMN_WIDTH map (availability-cell-helpers.tsx)
// instead of duplicating literals — single source of truth shared with the offer-draft
// Availability tab, keyed here by the lowercase Granularity union this surface uses.
export const GRANULARITY_COL_WIDTH: Record<Granularity, number> = {
  'half-month': AVAILABILITY_COLUMN_WIDTH.HALF_MONTH,
  month: AVAILABILITY_COLUMN_WIDTH.MONTH,
  week: AVAILABILITY_COLUMN_WIDTH.WEEK,
  day: AVAILABILITY_COLUMN_WIDTH.DAY,
};

export function AvailabilityGranularitySelect({
  value,
  onValueChange,
  testId,
}: {
  value: Granularity;
  onValueChange: (v: Granularity) => void;
  testId?: string;
}) {
  return (
    <Select value={value} onValueChange={(v) => onValueChange(v as Granularity)}>
      <SelectTrigger className="h-8 w-44 text-xs" data-testid={testId}>
        <SelectValue>{GRANULARITY_OPTIONS.find((o) => o.value === value)?.label}</SelectValue>
      </SelectTrigger>
      <SelectContent>
        {GRANULARITY_OPTIONS.map((o) => (
          <SelectItem key={o.value} value={o.value}>
            {o.label}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
